import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LineChart, XAxis, YAxis } from 'recharts';
import { useAppSelector } from '@shared/lib/hooks/useAppSelector';
import styles from './fixedAxis.scss';
const FixedAxis = () => {
    const dealsStats = useAppSelector(state => { var _a; return (_a = state.agents) === null || _a === void 0 ? void 0 : _a.dealsStats; });
    return _jsx("div", { className: styles.container, "data-sentry-component": "FixedAxis", "data-sentry-source-file": "index.tsx", children: _jsxs(LineChart, { width: 32, height: 180, data: dealsStats || [], margin: {
                left: -38,
                bottom: 0,
                top: 28
            }, "data-sentry-element": "LineChart", "data-sentry-source-file": "index.tsx", children: [_jsx(XAxis, { dataKey: "date", tickLine: false, tick: {
                        transform: 'translate(0, 6)'
                    }, className: styles.axis, "data-sentry-element": "XAxis", "data-sentry-source-file": "index.tsx" }), _jsx(YAxis, { tickLine: false, stroke: styles.greyColor, tick: {
                        stroke: styles.greyColor,
                        textAnchor: 'middle',
                        strokeWidth: 0
                    }, axisLine: false, dataKey: "dealsCount", allowDecimals: false, "data-sentry-element": "YAxis", "data-sentry-source-file": "index.tsx" })] }) });
};
export default FixedAxis;
